import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-content" }

import CSection from "@/components/section/CSection.vue";
import CSectionSubtitle from "@/components/section/CSectionSubtitle.vue";
import CSectionTitle from "@/components/section/CSectionTitle.vue";
import CSectionText from "@/components/section/CSectionText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CSectionOneColumn',
  props: {
  subtitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CSection, null, {
    default: _withCtx(() => [
      _createVNode(CSectionSubtitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.subtitle), 1)
        ]),
        _: 1
      }),
      _createVNode(CSectionTitle, { style: {"margin-bottom":"20px"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createVNode(CSectionText, {
        innerHTML: __props.text,
        style: {"margin-bottom":"80px"}
      }, null, 8, ["innerHTML"]),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}
}

})